import { render, staticRenderFns } from "./projectListAdvisor.vue?vue&type=template&id=f1965904"
import script from "./projectListAdvisor.vue?vue&type=script&lang=js"
export * from "./projectListAdvisor.vue?vue&type=script&lang=js"
import style0 from "./projectListAdvisor.vue?vue&type=style&index=0&id=f1965904&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports